export enum FilterWebSourceType {
    Total = "Total",
    Desktop = "Desktop",
    MobileWeb = "MobileWeb",
}
